import React from 'react';

interface OfferSectionProps {
	title: string;
	count?: number;
	children: React.ReactNode;
	titleClassName?: string;
}

export function OfferSection({title, count, children, titleClassName}: OfferSectionProps): React.ReactElement {
	return (
		<section className="mb-12 last:mb-0">
			<div className="flex items-center gap-1 mb-5">
				<h2 className={titleClassName ?? 'text-2xl font-medium text-black'}>{title}</h2>
				{count != null && <span className="-mt-3">{count}</span>}
			</div>
			{children}
		</section>
	);
}
